import LegacyCinePlayer from './LegacyCinePlayer';
export default LegacyCinePlayer;
